import {connect} from "react-redux";
import {AesInteractions, DispatchProps, InnerProps, StateProps} from "../components/AesInteractions";
import {RootState, ThunkDispatch} from "../types";
import {routerTools, Routes} from "../utils/router";
import {doDownloadAes, doDownloadAESXML, doGetAesJson, doGetAesSignatures} from "../actions/thunks/signatures";
import {gotAesJson, gotAesSignatures} from "../actions/signatures";
import {userIsAllowed} from "../utils/commons";
import {doGetUserCredits} from "../actions/thunks/users";

function mapStateToProps({user, aes}: RootState): StateProps {
    return {
        apiKeys: user.credentials,
        signatures: aes.signatures,
        total: aes.total,
        stats: user.credits?.document_aes_api,
        statsDocuments: user.credits?.document_aes_api_preservation,
        json: aes.json,
        isAllowed: userIsAllowed(user.credits, "document_aes_api"),
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch): DispatchProps {
    return {
        onGoToDocumentation: () => window.open(Routes.DOCS, "_blank"),
        onGoToApiKeys: () => routerTools.push(Routes.API_KEYS),
        onGetAesSignatures: (q) => dispatch(doGetAesSignatures(q)),
        onResetAesSignatures: () => dispatch(gotAesSignatures({items: undefined as any, total: 0})),
        onDownloadPdfXML: (sig) => dispatch(doDownloadAESXML(sig)),
        onGetAesJson: (sig) => dispatch(doGetAesJson(sig)),
        onCleanJson: () => dispatch(gotAesJson(undefined)),
        onDownloadPdf: (sig) => dispatch(doDownloadAes(sig)),
        onGetUserCredits: () => dispatch(doGetUserCredits()),
    };
}

export default connect<StateProps, DispatchProps, InnerProps, RootState>(mapStateToProps, mapDispatchToProps)(AesInteractions);
